import { type FC, useState } from "react";
import { useApi } from "../api/APIContext";
import { useApiCall } from "../api/api";
import type { Company } from "../api/dto";
import { Autocomplete } from "../components/form/Autocomplete";
import { Select } from "../components/form/Select";
import { ModalFooter } from "../components/layout/ModalProvider";
import { useRefresh } from "../components/RefreshController";

export const LinkCompanyModal: FC<{ company: Company }> = (props) => {
  const { companies } = useApi();
  const { attachParentCompany, attachChildCompany } = useApiCall();
  const refresh = useRefresh();
  const [mode, setMode] = useState<"child" | "parent">("child");
  const [company, setCompany] = useState<string>("");
  const companyMap = companies
    .filter((c) => !c.isArchived && c.id !== props.company.id)
    .map((c) => [c.id, c.name]);
  const selectedCompany = companies.find((c) => c.id === company);

  const save = async () => {
    if (!selectedCompany) {
      return;
    }
    if (mode === "child") {
      await attachChildCompany(props.company.id, selectedCompany.id);
    } else {
      await attachParentCompany(props.company.id, selectedCompany.id);
    }
    refresh();
  };
  return (
    <div className={""}>
      <div className={"min-h-[calc(220px+4rem)] flex-col space-y-3"}>
        <Select
          label="Relatie"
          value={mode}
          onChange={(x) => setMode(x as "child" | "parent")}
          options={{
            child: "Dochterbedrijf",
            parent: "Moederbedrijf",
          }}
        />
        <Autocomplete
          label={"Bedrijf"}
          value={company}
          options={Object.fromEntries(companyMap)}
          onChange={(c) => {
            setCompany(c);
          }}
        />
      </div>
      <ModalFooter text={"Opslaan"} onSubmit={save} disabled={!selectedCompany} />
    </div>
  );
};
